<ng-container *ngIf="hasApplied | async as status; else loading;">
  <ion-button *ngIf="!status.applied" color="tertiary" shape="round" (click)="isApply=!isApply">Apply Now</ion-button>
  <ion-button *ngIf="status.applied!='' && status.rejected!='' && status.accepted!=''" shape="round" color="warning" routerLink="/account/promote/feed" routerDirection="root">Applied {{ status.applied | date: 'd MMM' }}</ion-button>
  <ion-button *ngIf="status.applied!='' && status.rejected!='' && status.accepted!=''" shape="round" color="warning" fill="clear" class="ion-margin-left" routerLink="/account/promote/feed" routerDirection="root">Good Luck</ion-button>
  <ion-button *ngIf="status.rejected" shape="round" color="danger" routerLink="/account/promote/feed" routerDirection="root">Not successful {{ status.rejected | date: 'd MMM' }}</ion-button>
  <ion-button *ngIf="status.accepted" shape="round" color="success" routerLink="/account/promote/feed" routerDirection="root">Successful {{ status.accepted | date: 'd MMM' }}</ion-button>
</ng-container>
<ng-template #loading>
  <ion-button *ngIf="isApply" color="light" shape="round" (click)="isApply=!isApply">Apply Now</ion-button>
  <ion-button *ngIf="!isApply" color="tertiary" shape="round" (click)="isApply=!isApply">Apply Now</ion-button>
</ng-template>

<form [formGroup]="form" (submit)="save()" novalidate>
  <ng-container *ngIf="isApply">
    <ion-list class="ion-no-padding" lines="none">
      <ion-item class="ion-no-margin" color="light">
        <ion-textarea auto-grow="true" formControlName="message" rows="3" placeholder="Briefly explain why"></ion-textarea>
      </ion-item>
      <ion-item *ngIf="!f['message'].valid && f['message'].dirty" class="error-message" color="tertiary">
        <small *ngIf="f['message'].errors?.['required']">Please enter message</small>
        <small *ngIf="f['message'].errors?.['minlength']">Message more than 2 characters</small>
        <small *ngIf="f['message'].errors?.['maxlength']">Message less than 255 characters</small>
      </ion-item>
    </ion-list>
    <ion-button color="tertiary" (click)="save()" shape="round">Send</ion-button>
  </ng-container>
</form>